export default __webpack_public_path__ + "static/media/movieApp.0d41a481.png";